"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LendingInstruction = void 0;
var LendingInstruction;
(function (LendingInstruction) {
    LendingInstruction[LendingInstruction["InitLendingMarket"] = 0] = "InitLendingMarket";
    LendingInstruction[LendingInstruction["SetLendingMarketOwner"] = 1] = "SetLendingMarketOwner";
    LendingInstruction[LendingInstruction["InitReserve"] = 2] = "InitReserve";
    LendingInstruction[LendingInstruction["RefreshReserve"] = 3] = "RefreshReserve";
    LendingInstruction[LendingInstruction["DepositReserveLiquidity"] = 4] = "DepositReserveLiquidity";
    LendingInstruction[LendingInstruction["RedeemReserveCollateral"] = 5] = "RedeemReserveCollateral";
    LendingInstruction[LendingInstruction["InitObligation"] = 6] = "InitObligation";
    LendingInstruction[LendingInstruction["RefreshObligation"] = 7] = "RefreshObligation";
    LendingInstruction[LendingInstruction["DepositObligationCollateral"] = 8] = "DepositObligationCollateral";
    LendingInstruction[LendingInstruction["WithdrawObligationCollateral"] = 9] = "WithdrawObligationCollateral";
    LendingInstruction[LendingInstruction["BorrowObligationLiquidity"] = 10] = "BorrowObligationLiquidity";
    LendingInstruction[LendingInstruction["RepayObligationLiquidity"] = 11] = "RepayObligationLiquidity";
    LendingInstruction[LendingInstruction["FlashLoan"] = 13] = "FlashLoan";
    LendingInstruction[LendingInstruction["InitMining"] = 16] = "InitMining";
    LendingInstruction[LendingInstruction["RefreshMining"] = 17] = "RefreshMining";
    LendingInstruction[LendingInstruction["DepositMining"] = 18] = "DepositMining";
    LendingInstruction[LendingInstruction["WithdrawMining"] = 19] = "WithdrawMining";
    LendingInstruction[LendingInstruction["ClaimMiningMine"] = 20] = "ClaimMiningMine";
    LendingInstruction[LendingInstruction["ClaimObligationMine"] = 21] = "ClaimObligationMine";
    LendingInstruction[LendingInstruction["RefreshReserves"] = 24] = "RefreshReserves";
    LendingInstruction[LendingInstruction["LiquidateObligation"] = 25] = "LiquidateObligation";
    LendingInstruction[LendingInstruction["ClaimMine"] = 26] = "ClaimMine";
})(LendingInstruction = exports.LendingInstruction || (exports.LendingInstruction = {}));
